/* global localStorage */
import moment from 'moment';
import { clearSession } from './auth_session';

class TokenService {
  getRefreshToken () {
    const token = JSON.parse(localStorage.getItem('token'));
    return token?.refreshToken;
  }

  getAccessToken () {
    const token = JSON.parse(localStorage.getItem('token'));
    return token?.accessToken;
  }

  updateToken (token) {
    localStorage.setItem('token', JSON.stringify(token));
  }

  getMember () {
    return JSON.parse(localStorage.getItem('member'));
  }

  setMember (member) {
    localStorage.setItem('member', JSON.stringify(member));
  }

  clear () {
    const current = window.location.pathname + window.location.search + window.location.hash;
    const loginPath = window.location.pathname.startsWith('/watersupply/admin')
      ? '/watersupply/admin/login'
      : '/agra/login';
    clearSession();
    window.location.replace(`${loginPath}?redirect=${encodeURIComponent(current)}`);
  }

  isLogin () {
    const token = JSON.parse(localStorage.getItem('token'));
    return token !== null;
  }

  isExpired () {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token != null) {
      if (moment(token.expiresIn).isAfter()) {
        return false;
      }
    }
    return true;
  }
}
export default new TokenService();
